import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const putOperatorOffline = async (id: string) => {
  const response = await mutationExecute({
    variables: { id },
    mutation: graphql(`
      mutation PutOperatorOffline($id: String!) {
        putOperatorOffline(id: $id) {
          id
          firstName
          lastName
          email
          phoneNumber
          textNumber
          language1
          language2
          workerSid
          departments
          slackId
          slackWebHook
          slackAlertWebHook
          defaultType
          isDefaultOnly
          closedAt
          slingUserId
          isRehireEligible
          suspendedAt
          isSuspended
          isRecordAllCalls
          isEnableRegFlowView
        }
      }
    `),
  });

  return response.data?.putOperatorOffline;
};
